module.exports = __webpack_public_path__ + "media/images/ohap_gradebook_off-3c2f630dec54a5ea9d7b016d6a41a5a2.png";